import {googleLogout} from '@react-oauth/google';
import {fetchBaseQuery, BaseQueryFn, FetchArgs, FetchBaseQueryError} from '@reduxjs/toolkit/query';

import {browserStorageKey} from '../constants/browserStorageKey';

const baseQuery = fetchBaseQuery({baseUrl: 'https://europe-west1-proxy-7eac9.cloudfunctions.net'});
export const academyBaseQuery: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError
> = async (args, api, extraOptions) => {
  const result = await baseQuery(args, api, extraOptions);
  if (result.error && result.error.status === 401) {
    googleLogout();
    sessionStorage.removeItem(browserStorageKey.ACCESS_TOKEN);
    window.location.href = '/';
  }
  return result;
};
